import { validateNumber, validateString } from 'avilatek-utils';
import { TDCPayment } from '../../models';

export function validateTdcForm({
  cardname,
  dni,
  typetdc,
  cardnumber,
  expirationdate,
  cvc,
  amount,
}: TDCPayment): string {
  if (!validateString(cardname) || cardname === '') {
    return 'Debes ingresar el nombre del titular de la tarjeta';
  }
  if (!validateString(dni) || dni.length < 6) {
    return 'Debes ingresar un número de cédula válido';
  }
  if (
    !validateString(cardnumber) ||
    cardnumber.length < 15 ||
    cardnumber.length > 16
  ) {
    return 'Debes ingresar un número de tarjeta válido';
  }
  if (typetdc !== 'visa' && typetdc !== 'mastercard') {
    return 'Solo se aceptan tarjetas Visa o MasterCard';
  }
  if (!validateNumber(cvc) || cvc.length !== 3) {
    return 'Debes ingresar el código de seguridad valido';
  }
  if (!validateString(expirationdate) || expirationdate === '') {
    return 'Debes ingresar la fecha de expiración';
  }
  if (!validateNumber(amount) && amount <= 0) {
    return 'Debes ingresar un monto válido';
  }

  return '';
}
